export default __webpack_public_path__ + "static/pragicts-secops-banner-we-have-you-covered-04eb07410c8ee1b068db739e7f17c53d.jpg";